/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Page_DescriptionInputs */

const en_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const de_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const fr_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const es_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const it_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const nl_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const pl_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const fi_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const da_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

const sv_deep_match_page_description = /** @type {(inputs: Deep_Match_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-dimension job scoring — see how well you match before applying.`)
};

/**
* | output |
* | --- |
* | "Multi-dimension job scoring — see how well you match before applying." |
*
* @param {Deep_Match_Page_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_page_description = /** @type {((inputs?: Deep_Match_Page_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Page_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_page_description(inputs)
	if (locale === "fr") return fr_deep_match_page_description(inputs)
	if (locale === "es") return es_deep_match_page_description(inputs)
	if (locale === "it") return it_deep_match_page_description(inputs)
	if (locale === "nl") return nl_deep_match_page_description(inputs)
	if (locale === "pl") return pl_deep_match_page_description(inputs)
	if (locale === "fi") return fi_deep_match_page_description(inputs)
	if (locale === "da") return da_deep_match_page_description(inputs)
	if (locale === "sv") return sv_deep_match_page_description(inputs)
	return en_deep_match_page_description(inputs)
});